import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import caveatColor from '../caveatColor';
import PropTypes from 'prop-types';

class CaveatEditor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      score: props.score || 0,
      title: props.title || "",
      active: props.title && props.title.length > 0,
      hasChanged: false
    }
    this.onTextChange = this.onTextChange.bind(this);
    this.onDropDownMenuChange = this.onDropDownMenuChange.bind(this);
    this.isActive = this.isActive.bind(this);
  }

  isActive() {
    return this.state.active;
  }

  hasChanged() {
    return this.state.hasChanged;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render(){
    let style = {paddingLeft: 10};
    var color = "grey";
    var bgColor = "rgb(247, 247, 247)";
    var tdStyle = {padding: "0px 10px"};
    var firstTdStyle = {
      ...tdStyle
    }

    if (this.state.active) {
      let colors = caveatColor(this.state.score);
      color = colors.primary;
      bgColor = colors.background;
      firstTdStyle.borderLeft = "4px solid " + color;
      style.backgroundColor = bgColor;
    } else {
      firstTdStyle.borderLeft = "4px solid white";
    }
    return (
      <tr style={style}>
        <td style={{...firstTdStyle, maxWidth: 200}}>{this.props.answerText}</td>
        <td style={{...tdStyle, width: 200}}>
          <DropDownMenu
            style={{width: 200}}
            value={this.state.score}
            onChange={this.onDropDownMenuChange}
          >
            <MenuItem value={2} primaryText="Green (2)" />
            <MenuItem value={-1} primaryText="Yellow (-1)" />
            <MenuItem value={-2} primaryText="Orange (-2)" />
            <MenuItem value={-3} primaryText="Red (-3)" />
          </DropDownMenu>
        </td>
        <td style={tdStyle}>
          <TextField
            ref="title"
            hintText="Caveat Disabled Without Text"
            defaultValue={this.state.title}
            onChange={this.onTextChange}
            style={{marginLeft: 20, marginBottom: -15, width:"95%"}}
            multiLine={true}
            rowMax={Infinity}
          />
        </td>
      </tr>
    )
  }

  onTextChange(e, value) {
    let active = value.length > 0;
    if (active !== this.state.active) {
      setTimeout(this.props.onChange, 0);
    }
    this.setState({
      title: value,
      active: active,
      hasChanged: true
    });
  }

  onDropDownMenuChange(e, i, value) {
    this.setState({
      score: value,
      hasChanged: true
    });
    setTimeout(this.props.onChange, 0);
  }

  getValue() {
    if (!this.state.title || this.state.title.length === 0) {
      return undefined;
    } else {
      return {
        title: this.state.title,
        score: this.state.score
      }
    }
  }

}

CaveatEditor.propTypes = {
  score: PropTypes.number,
  title: PropTypes.string,
  answerText: PropTypes.string.isRequired
}

CaveatEditor.defaultProps = {
  title: "",
  score: 0
}

export default CaveatEditor;
